import type { GetPropertyCoveragesResponse } from '@/shared/types';

import { apiUri } from '@/constants/Constants';
import { DdClient } from '@/features/DealsDashboard/service/DealsDashboardAPI';

export const getPropertyCoverages = async (propertyId: string) => {
  const response = await DdClient.get<GetPropertyCoveragesResponse>(
    apiUri.getPropertyCoverages.replace('{propertyId}', propertyId),
  );
  return response.data?.data?.coverage_rules ?? [];
};
